export default IconCurrencyZloty => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-zloty" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 18h-7l7 -7h-7" />
  <path d="M17 18v-13" />
  <path d="M14 14.5l6 -3.5" />
</svg>`;